import { getBrandBasedIn } from "@faire/help-center-utils/serialized-data/getBrand";
import { ISelfServeBrandOrder } from "@faire/web-api--source/indigofair/helpcenter/ISelfServeBrandOrder";
import { ISO3166Alpha3 } from "@faire/web-api--source/indigofair/iso3166/ISO3166Alpha3";

import { NODE_IS_NOT_VISIBLE, NODE_IS_VISIBLE } from "../../api/consts";
import { SelfServeContext } from "../../types";

export const orderUnknownStateVisibilityFn = (context: SelfServeContext) => {
  if (!context.selectedBrandOrder) {
    return Promise.resolve(NODE_IS_VISIBLE);
  }
  return Promise.resolve(
    getOrderState(context) === ISelfServeBrandOrder.State.STATE_UNKNOWN
  );
};

export const orderNewStateVisibilityFn = (context: SelfServeContext) => {
  if (!context.selectedBrandOrder) {
    return Promise.resolve(NODE_IS_NOT_VISIBLE);
  }
  return Promise.resolve(
    getOrderState(context) === ISelfServeBrandOrder.State.NEW
  );
};

export const orderUnfulfilledStateVisibilityFn = (
  context: SelfServeContext
) => {
  if (!context.selectedBrandOrder) {
    return Promise.resolve(NODE_IS_NOT_VISIBLE);
  }
  return Promise.resolve(
    getOrderState(context) === ISelfServeBrandOrder.State.UNFULFILLED
  );
};

export const orderShippedStateVisibilityFn = (context: SelfServeContext) => {
  if (!context.selectedBrandOrder) {
    return Promise.resolve(NODE_IS_NOT_VISIBLE);
  }
  return Promise.resolve(
    getOrderState(context) === ISelfServeBrandOrder.State.SHIPPED
  );
};

export const orderDeliveredStateVisibilityFn = (context: SelfServeContext) => {
  if (!context.selectedBrandOrder) {
    return Promise.resolve(NODE_IS_NOT_VISIBLE);
  }
  return Promise.resolve(
    getOrderState(context) === ISelfServeBrandOrder.State.DELIVERED
  );
};

export const orderCanceledStateVisibilityFn = (context: SelfServeContext) => {
  if (!context.selectedBrandOrder) {
    return Promise.resolve(NODE_IS_NOT_VISIBLE);
  }
  return Promise.resolve(
    getOrderState(context) === ISelfServeBrandOrder.State.CANCELED
  );
};

export const orderShippedOrDeliveredAndSOYOVisibilityFn = (
  context: SelfServeContext
) => {
  if (!context.selectedBrandOrder) {
    return Promise.resolve(NODE_IS_NOT_VISIBLE);
  }
  return Promise.resolve(
    (getOrderState(context) === ISelfServeBrandOrder.State.SHIPPED ||
      getOrderState(context) === ISelfServeBrandOrder.State.DELIVERED) &&
      !context.selectedBrandOrder?.is_ship_with_faire &&
      getBrandBasedIn() === ISO3166Alpha3.USA
  );
};

const getOrderState = (
  context: SelfServeContext
): keyof typeof ISelfServeBrandOrder.State | undefined => {
  const { selectedBrandOrder } = context;
  const { state } = selectedBrandOrder ?? {};
  return state;
};
